<template>
  <div>
    <div class="mb-6 pb-6 border-b-2 border-grey-light flex flex-wrap items-center">
      <div>
        <h1 class="text-grey-darker text-xl font-semibold leading-normal uppercase">
          Event Booking Successful
        </h1>
      </div>
    </div>

    <loader v-if="!loaded" />

    <!-- OFFICE HAS NO ACCESS -->
    <panel v-else-if="!officeAccess" class="pt-6">
      <strong class="mb-2">Access Denied</strong>
      <p>Your office does not have access to use this system.</p>
    </panel>

    <div v-else-if="!error" class="rounded-lg bg-white relative w-full py-8 px-4">
      <div class="max-w-lg mx-auto text-center">
        <h3 class="flex justify-center items-center mb-1 leading-none">Event Registration</h3>
        <icon name="tick_circle" :center="false" class="mx-auto mb-1 w-32 h-32 text-green" />
        <h3 class="text-center mb-4">Thank you for your Payment</h3>
        <p class="mb-2">Your payment for the {{ ticket.event_name }} was successful.</p>
        <p class="mb-2">An email receipt confirming your booking will be sent to <strong>{{ order.email }}</strong></p>
        <p class="mb-6 font-bold">We look forward to seeing you there.</p>
        <hr class="border-b border-grey-light mb-6">
        <table v-if=" attendees.length > 0 " class="w-full leading-normal border-bottom">
          <tbody v-for="(registrant, i) in attendees" :key="i" class="border-b border-transparent">
          <tr><td colspan="2" class="align-top text-sm font-bold">{{ registrant.name }}</td></tr>
          <tr><td colspan="2" class="align-top text-sm">{{ registrant.email }}</td></tr>
          <tr class="border-bottom">
            <td class="text-sm pb-4">
              Dietary Requirements: {{ registrant.dietary_requirements ? registrant.dietary_requirements : 'None' }} /
              Allergies: {{registrant.allergies ? registrant.allergies : 'None'}}
            </td>
            <td class="text-sm pb-4 text-right">
              {{ ticket.price_after_discount | gbp }}
            </td>
          </tr>
          </tbody>
        </table>
        <div v-if="attendees.length > 0" class="px-4 pt-6 text-sm">
          <div v-if="ticket.is_free" class="pb-3">Free Entry</div>
          <div v-if="appliedDiscountRules">
            <div  class="pb-3" v-for="(rule,i) in appliedDiscountRules" :key="i">{{ rule.name }}</div>
          </div>
        </div>
        <table class="w-full mb-4">
          <tbody>
          <tr>
            <td class="align-top text-sm pb-3">
              Sub Total
            </td>
            <td class="align-top text-right text-sm pb-3">{{ subtotal | gbp }}</td>
          </tr>
          <tr v-if="vat !== 0">
            <td class="align-top text-sm pb-3">
              VAT (20%)
            </td>
            <td class="align-top text-right text-sm pb-3">{{ vat | gbp }}</td>
          </tr>
          <tr>
            <td class="align-top text-sm font-bold">
              Total
            </td>
            <td class="align-top text-right text-sm font-bold">{{ total | gbp }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="rounded-lg bg-white relative w-full py-8 px-4">
      <div class="max-w-lg mx-auto text-center">
        <h3 class="flex justify-center items-center mb-1 leading-none">Event Registration</h3>
        <icon name="close_small" :center="false" class="mx-auto mb-1 w-32 h-32 text-red" />
        <h3 class="text-center mb-4">Something is Wrong</h3>
        <div>We are sorry that your order is not completed. Please contact administrator.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { v2Api } from '@/http'

export default {
  data () {
    return {
      loaded: false,
      officeAccess: true,
      ticket: null,
      order: null,
      attendees: null,
      error: false
    }
  },
  computed: {
    ...mapState(['selectedOffice']),
    subtotal () {
      let discountNum = 0
      let discountPertentage = 0
      if (this.ticket.is_free) {
        return 0
      }
      for (let rule of this.ticket.selected_discount_rules) {
        if (this.attendees.length >= rule.base_number) {
          if (rule.free_number) {
            discountNum = discountNum > rule.free_number ? discountNum : rule.free_number
          }
          if (rule.discount_percentage) {
            discountPertentage = discountPertentage > rule.discount_percentage ? discountPertentage : rule.discount_percentage
          }
        }
      }

      return this.ticket.price_after_discount && this.attendees.length
        ? (this.ticket.price_after_discount * (this.attendees.length - discountNum) * (1 - discountPertentage)) : 0
    },
    vat () {
      if (this.selectedOffice.country !== 'GB') {
        return 0
      }
      return this.subtotal * 0.2
    },
    total () {
      return this.subtotal + this.vat
    },
    appliedDiscountRules: function () {
      let appliedDiscountRules = []
      if (this.ticket.discount_rules) {
        if (this.ticket.is_free) {
          return []
        }

        let ticketNum = this.attendees.length
        for (var index in this.ticket.discount_rules) {
          let discountRule = this.ticket.discount_rules[index]
          if (ticketNum >= discountRule.base_number) {
            appliedDiscountRules.push(discountRule)
          }
        }
        return appliedDiscountRules
      }

      return []
    }
  },
  created () {
    Promise.all([
      this.loadOrder()
    ]).catch((errors) => {
      this.displayToastNotification({
        type: 'warning',
        icon: 'fa-exclamation-triangle',
        title: 'Order Not Found',
        info: errors.response.data.message
      })
    })
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    loadOrder () {
      return v2Api.get(`event-orders/${this.$route.params.orderId}/payment-successful`).then((response) => {
        this.loaded = true
        if (response.data.result) {
          this.ticket = response.data.ticket
          this.attendees = response.data.attendees
          this.order = response.data.order
        } else {
          this.error = true
        }
      })
    }
  }
}
</script>
